import React, { CSSProperties } from 'react';
import classNames from 'classnames';

type Props = {
  style?: CSSProperties;
  onClick?: () => void;
  className?: string;
  direction: 'left' | 'right' | 'up' | 'down';
};

const ArrowNavigation = ({ className, onClick, direction, style }: Props) => {
  const groupProps = {
    style,
    className: classNames('arrow-navigation', direction, className),
  };

  return (
    <div {...groupProps} onClick={onClick}>
      <i className={classNames('arrow-icon', `icon-cheveron-${direction}`)} />
    </div>
  );
};
export default ArrowNavigation;
